import type { PIIString } from '@trello/privacy';

import { MemberProfilePage } from 'app/src/components/MembersPages/MemberProfilePage';
import { controllerEvents } from './controllerEvents';
import { renderTopLevelComponent } from './renderTopLevelComponent';

export const memberProfilePageController = async ({
  username,
}: {
  username: PIIString;
}) => {
  controllerEvents.trigger('clearPreviousView');
  controllerEvents.trigger('setViewType', 'MembersView');
  renderTopLevelComponent(<MemberProfilePage username={username} />);
};
